import { StyledButton, StyledButtonAnchor } from './Button.Styled'

const Button = ({
  text,
  onClick,
  href,
  className,
  margin,
  width,
  color,
  backgroundColor,
  variant,
  type = 'button',
  minimized = false,
}) => {
  if (href) {
    return (
      <StyledButtonAnchor
        minimized
        href={href}
        className={className}
        margin={margin}
        width={width}
        color={color}
        variant={variant}
        backgroundColor={backgroundColor}
      >
        {text}
      </StyledButtonAnchor>
    )
  }
  return (
    <StyledButton
      minimized
      onClick={onClick}
      className={className}
      margin={margin}
      type={type}
      width={width}
      color={color}
      variant={variant}
      backgroundColor={backgroundColor}
    >
      {text}
    </StyledButton>
  )
}

export default Button
